let amapLoaderPromise = null

function getExistingAmap() {
  if (typeof window !== 'undefined' && window.AMap) {
    return window.AMap
  }
  return null
}

export function loadAmap(key) {
  const existing = getExistingAmap()
  if (existing) {
    return Promise.resolve(existing)
  }

  if (!key) {
    return Promise.reject(new Error('missing amap key'))
  }

  if (amapLoaderPromise) {
    return amapLoaderPromise
  }

  amapLoaderPromise = new Promise((resolve, reject) => {
    const callbackName = `__amapInit_${Date.now()}`
    const script = document.createElement('script')

    window[callbackName] = function onAmapLoaded() {
      const amap = getExistingAmap()
      delete window[callbackName]
      if (amap) {
        resolve(amap)
      } else {
        reject(new Error('amap load failed'))
      }
    }

    script.src = `https://webapi.amap.com/maps?v=2.0&key=${encodeURIComponent(key)}&plugin=AMap.PlaceSearch,AMap.Geocoder&callback=${callbackName}`
    script.async = true
    script.onerror = () => {
      delete window[callbackName]
      amapLoaderPromise = null
      reject(new Error('amap script load failed'))
    }

    document.head.appendChild(script)
  })

  return amapLoaderPromise
}
